
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18.06"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.55.146A2.538 2.538 0 00.024 2.674v12.945a2.538 2.538 0 002.528 2.527h3.584a2.538 2.538 0 002.527-2.527V2.674A2.538 2.538 0 006.135.146H2.55zm0 1.504h3.585c.58 0 1.023.444 1.023 1.024v12.945c0 .58-.443 1.024-1.023 1.024H2.55c-.58 0-1.024-.444-1.024-1.024V2.674c0-.58.444-1.024 1.024-1.024zM13.639.167a.64.661 0 00-.539.376l-.95 2.077-2.194.366A.64.661 0 009.62 4.12l1.616 1.576-.34 2.27a.64.661 0 00.94.68l1.948-1.102 1.983 1.037a.64.661 0 00.917-.713l-.411-2.257 1.564-1.629a.64.661 0 00-.372-1.121l-2.203-.294L14.246.525a.64.661 0 00-.607-.358zM13.7 2.32l.578 1.16a.64.661 0 00.486.354L16.016 4l-.889.925a.64.661 0 00-.174.59l.233 1.28-1.126-.587a.64.661 0 00-.595.009l-1.107.625.194-1.287a.64.661 0 00-.194-.583l-.918-.895 1.245-.208a.64.661 0 00.476-.37l.54-1.179zm-1.77 7.342a2.465 2.465 0 00-2.457 2.455v3.559a2.465 2.465 0 002.457 2.455h3.584a2.464 2.464 0 002.455-2.455v-3.559a2.464 2.464 0 00-2.455-2.455H11.93zm0 1.299h3.584c.65 0 1.154.505 1.154 1.156v3.559c0 .65-.503 1.154-1.154 1.154H11.93a1.139 1.139 0 01-1.157-1.154v-3.559a1.14 1.14 0 011.157-1.156z","font-family":"sans-serif","overflow":"visible","paint-order":"stroke fill markers"}})])
          )
        }
      }
    